import { render, staticRenderFns } from "./PostListItem.vue?vue&type=template&id=9573f85c"
import script from "./PostListItem.vue?vue&type=script&lang=js"
export * from "./PostListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports